var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-item"},[_c('button',{staticClass:"item-icon",class:{'activity': _vm.choose},attrs:{"data-info":_vm.name,"data-type":_vm.type},on:{"click":function($event){_vm.iconClick($event, _vm.type)}}},[(_vm.icon.length > 0)?_c('i',{staticClass:"iconfont",class:_vm.icon}):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43369fe3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/icon.vue
// module id = null
// module chunks = 